import { Pipe, PipeTransform } from '@angular/core';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';
import { StorageService } from 'src/app/services/security/storage.service';

@Pipe({
  name: 'decimalPrecision'
})
export class DecimalPrecisionPipe implements PipeTransform {

  constructor(private ls: StorageService) { }

  transform(value: any, args?: any): any {
    let numberValue = Number(value);
    if((numberValue == null || isNaN(numberValue)))  return value;

    let precision = Number(this.ls.get(localStorageAccessConstant.decimalPrecision));
    if (Number.isFinite(precision) && precision > 0) {
      return numberValue.toFixed(precision);
    }
    return numberValue.toFixed(4);
    }
}
